// Copyright (c) 2020 Deere & Company

import React, {PropTypes} from 'react';
import Attachments from '../../../shared/components/attachments';
import LabeledString from '../../../../shared/components/labeled-string';
import LawEnforcementInfo from './law-enforcement-info';
import StatusChange from '@deere/cps-it.warranty-model-factory/lib/status-change';
import {buildDate} from '../../../../shared/services/build-date';
import {buildDealer} from '../../../../shared/services/build-dealer';
import {translatedMachinePutBackStatus} from '../../../../shared/services/machine-put-back-status.js';

const MachineStatusInfo = props =>
    <div className='machine-status-info'>
        <div className='row'>
            <LabeledString
                className='dealer-location'
                data={buildDealer(props.statusChangeObject.product.dealer)}
                label='DEALER_LOCATION'
            />
        </div>
        <div className='row'>
            <LabeledString
                className='model'
                data={props.statusChangeObject.product.model}
                label='MODEL'
            />
            <LabeledString
                className='customer'
                data={props.statusChangeObject.product.customerSummary.displayName}
                label='CUSTOMER'
            />
        </div>
        <div className='row'>
            <LabeledString
                className='created-by'
                data={props.statusChangeObject.createdBy.buildUserName()}
                label='CREATED_BY'
            />
            <LabeledString
                className='created-on'
                data={buildDate(props.statusChangeObject.createdDate)}
                label='CREATED_ON'
            />
        </div>
        <div className='row'>
            <LabeledString
                className='dealer-comments'
                data={props.statusChangeObject.comments}
                label='DEALER_COMMENTS'
            />
        </div>
        {(props.statusChangeObject.newStatus.key === 'EOOS' || props.statusChangeObject.newStatus.key === 'DMGD') &&
            <div>
                <div className='row'>
                    <LabeledString
                        className='damage-event-date'
                        data={buildDate(props.statusChangeObject.damageEventDate)}
                        label='DATE_OF_EVENT_CAUSING_DAMAGE'
                    />
                    <LabeledString
                        className='machine-put-back'
                        data={translatedMachinePutBackStatus(props.statusChangeObject.machinePutBack)}
                        label='CAN_THE_MACHINE_BE_PUT_BACK_INTO_SERVICE'
                    />
                </div>
                <div className='row'>
                    <LabeledString
                        className='description-of-damage'
                        data={props.statusChangeObject.damageDesc}
                        label='DESCRIPTION_OF_DAMAGE'
                    />
                    <LabeledString
                        className='description-causing-damage'
                        data={props.statusChangeObject.damageEventDesc}
                        label='DESCRIPTION_OF_EVENT_CAUSING_DAMAGE'
                    />
                </div>
            </div>
        }
        {props.statusChangeObject.newStatus.key === 'LCUK' &&
            <div className='row'>
                <LabeledString
                    className='last-contact-date'
                    data={buildDate(props.statusChangeObject.lastContactDetails.lastContactDate)}
                    label='DATE_OF_LAST_PERSONAL_CONTACT'
                />
                <LabeledString
                    className='certified-letter-date'
                    data={buildDate(props.statusChangeObject.lastContactDetails.letterSentDate)}
                    label='DATE_OF_CERTIFIED_LETTER'
                />
            </div>
        }
        <div className='row'>
            {props.statusChangeObject.newStatus.key === 'STL1' &&
                <LawEnforcementInfo lawEnforcementInfo={props.statusChangeObject.lawEnforcementDetails}/>
            }
            <Attachments files={props.statusChangeObject.file}/>
        </div>
    </div>;

MachineStatusInfo.displayName = 'MachineStatusInfo';
MachineStatusInfo.propTypes = {
    statusChangeObject: PropTypes.instanceOf(StatusChange).isRequired
};

export default MachineStatusInfo;



// WEBPACK FOOTER //
// ./src/tcsm/wip/components/machine-status-updates/machine-status-info.js